import React, { Component } from 'react';
import { ActivableRenderer, Dialog } from "~/native-ui"

class _Dialog extends Component {

    defaultProps = {
        actions: [],
        active: false,
		preload: false,
        type: 'normal',
    };

    componentDidMount() {
    }

    componentWillUnmount() {
    }

	render() {
		let	props = this.props,
			{ active, preload } = props;

		let isReallyActive = props.active && !preload;

		return (
			<Dialog {...props} active={ isReallyActive }>
				{this.props.children}
			</Dialog>
		);
	}
}

const SimpleDialog =  ActivableRenderer()(_Dialog);

export default SimpleDialog;